import React, { ReactElement } from 'react'
import Typography from '@material-ui/core/Typography'
import { makeStyles } from '@material-ui/core/styles'
import Image, { ImageProps } from './Image'
import StringItem, { StringItemProps } from './StringItem'
import { printConfig } from '../../config'

const useStyles = makeStyles(theme => ({
  group: {
    margin: theme.spacing(0.75, 0)
  },
  divider: {
    margin: theme.spacing(0, -2),
    padding: theme.spacing(2, 0, 1)
  },
  topic: {
    margin: theme.spacing(2, 0, 1),
    padding: theme.spacing(0.75, 0),
    fontWeight: theme.typography.fontWeightBold,
    wordWrap: 'break-word',
    overflowWrap: 'break-word',
    '@media print': {
      fontFamily: printConfig.topic.fontName,
      fontWeight: theme.typography.fontWeightBold,
      fontSize: printConfig.topic.fontSize
    }
  }
}))

export interface TopicItemProps {
  topicId: string
  text: string
  images: ImageProps[]
  strings: StringItemProps[]
}

function TopicItem({ topicId, text, images, strings }: TopicItemProps): ReactElement {
  const classes = useStyles()
  return (
    <section id={`topic_${topicId}`} className={classes.group}>
      <Typography color="textSecondary" className={classes.topic}>
        {text}
      </Typography>
      {images.map(image => (
        <Image key={image.imageId} {...image} />
      ))}
      {strings.map(item => (
        <StringItem key={item.stringId} {...item} />
      ))}
      <div className={classes.divider} />
    </section>
  )
}

export default TopicItem
